require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-imagineering-dis-ability.json") })
        }
      }, "path---projects-imagineering-dis-ability");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-imagineering-dis-ability!./.cache/json/projects-imagineering-dis-ability.json
// module id = 344
// module chunks = 231608221292675